import { GAME_CONFIG } from "./config";
import { ZoneId } from "./zones";

const { TILE_SIZE } = GAME_CONFIG;

export type NpcKind = "git_master" | "hr_manager" | "signpost";

export interface NpcDef {
  id: string;
  kind: NpcKind;
  zone: ZoneId;
  x: number;
  y: number;
  color: number;         // fill color for the square marker
  interactRange: number; // px
  label: string;         // floating label
  lines: string[];       // dialogue lines (empty for pure signposts shown as label)
}

function tileCenter(col: number, row: number) {
  return { x: col * TILE_SIZE + TILE_SIZE / 2, y: row * TILE_SIZE + TILE_SIZE / 2 };
}

export const NPCS: NpcDef[] = [
  {
    id:   "git_master",
    kind: "git_master",
    zone: "zone_gangnam",
    ...tileCenter(9, 24),
    color: 0x9b59b6,
    interactRange: 48,
    label: "깃 마스터",
    lines: [
      "어서와, 이 바닥은 처음이지? 나는 깃 마스터야.",
      "여기선 뭘 하든 집중력(⚡)이 필요해. 화면 왼쪽 위에 보이지? 시간이 지나면 회복되니까 아껴 쓰라고.",
      "git commit은 세이브 포인트야. 자주 저장하면 후회가 없어. 자, 일부터 배워보자.",
    ],
  },
  {
    id:   "hr_manager",
    kind: "hr_manager",
    zone: "zone_gangnam",
    ...tileCenter(13, 24),
    color: 0x2e86c1,
    interactRange: 48,
    label: "인사팀 차장",
    lines: [
      "어험. 인사팀 차장이다. 전직 시험을 담당하고 있지.",
      "수습 딱지를 떼고 싶다고? 기초 스킬 6종을 전부 익히고, 맑은 정신(집중력 30)으로 오도록.",
      "시험은 다섯 문제. 네 문제 이상 맞히면 주니어다. 준비됐으면 시작하지.",
    ],
  },
];

export interface QuestState {
  status: "inactive" | "active" | "completed";
}

export type QuestMap = Record<string, QuestState>;
